import axios from '../axios'
import config from '../config'
import R from 'ramda'
import { maxPrice, maxRooms, maxYield } from '../Utils/Constants'

export const searchLocations = (criteria = {}) => {
  return axios.post(
    `${config.SERVER_URL}/preference/search_locations`,
    criteria
  )
}

export const searchCategories = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/category/find`, criteria)
}

export const searchCities = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/city/find`, criteria)
}

export const searchContinents = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/continent/find`, criteria)
}

export const searchContinentsWithProperties = () => {
  return axios.post(`${config.SERVER_URL}/continent/search`)
}

export const searchCountriesWithProperties = ({ id, skip = 0, limit = 30 }) => {
  return axios.post(`${config.SERVER_URL}/country/search`, {
    continentId: id,
    skip,
    limit
  })
}

export const searchCitieswithProperties = ({ id, skip = 0, limit = 30 }) => {
  return axios.post(`${config.SERVER_URL}/city/search`, {
    countryId: id,
    skip,
    limit
  })
}

export const searchCountries = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/country/find`, criteria)
}

export const findCategoryByName = name => {
  return axios.post(`${config.SERVER_URL}/category/find`, {
    where: {
      name: {
        startsWith: name
      }
    }
  })
}

export const searchProperties = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/property/find`, criteria)
}

export const searchPublicCity = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/public/city`, criteria)
}

export const searchPublicCountry = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/public/country`, criteria)
}

export const searchPublicContinent = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/public/continent`, criteria)
}

export const findCityByName = city => {
  return axios.get(
    config.SERVER_URL +
      '/city?where={"city":{"contains":"' +
      city +
      '"}}&sort="city ASC"'
  )
}

export const findProperties = ({ settings = {}, skip = 0, limit = 30 }) => {
  let criteria = R.clone(settings)

  let params = {
    limit,
    skip,
    sort: 'title ASC'
  }

  criteria.preferredCategories = criteria.preferredCategories
    ? criteria.preferredCategories.map(category => category.id)
    : []
  criteria.preferredCities = criteria.preferredCities
    ? criteria.preferredCities.map(city => city.id)
    : []
  criteria.preferredCountries = criteria.preferredCountries
    ? criteria.preferredCountries.map(country => country.id)
    : []
  criteria.preferredRegions = criteria.preferredRegions
    ? criteria.preferredRegions.map(region => region.id)
    : []

  if (criteria.maxInvestment === maxPrice) {
    delete criteria.maxInvestment
  }

  if (criteria.maxNoRooms === maxRooms) {
    delete criteria.maxNoRooms
  }

  if (criteria.maxYield === maxYield) {
    delete criteria.maxYield
  }

  return axios.post(`${config.SERVER_URL}/property/search`, {
    criteria,
    params
  })
}

export const findPropertyById = id => {
  return axios.get(config.SERVER_URL + '/property/' + id)
}

export const findPropertiesById = ids => {
  const propertyIds = ids.map(id => {
    return '"' + id + '"'
  })
  return axios.get(
    config.SERVER_URL + '/property/?where={"id":[' + propertyIds + ']}'
  )
}

export const fetchCategories = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/category/find`, criteria)
}

export const fetchPublicCategories = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/public/category`, criteria)
}



// WEBPACK FOOTER //
// ./src/sources/SearchSource.js